import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const view = (values) => {
  const request = buildClientHistoryListRequest("afterlogin/client/clientinvoice", values || {});
  const data = request.body;
  if (values?.category) data.category = values.category;
  if (values && values.include_inactive === true) data.include_inactive = true;
  return axios.post(API_URL + request.url, data, { headers: authHeader() });
};

const hideInvoice = (values) => {
  const action = "afterlogin/sale/hideinvoice";
  const data = {
    id: values && values.id ? Number(values.id) : 0,
    is_active: Boolean(values && values.is_active),
  };

  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const clientinvoiceApiController = {
  view,
  hideInvoice,
};
export default clientinvoiceApiController;
